import { Dispatch, SetStateAction } from 'react';

import { Box } from '@mui/material';

import { PanelGrid } from 'components/grid';
import { ContentModal } from 'components/modal';
import { SubTitle } from 'components/text';
import { useQueryDetalhamentoImportacaoValidacao } from 'pages/financeiro/detalhamento-creditos/importar/hooks';
import { DetalhamentoImportacaoValidacao } from 'pages/financeiro/detalhamento-creditos/importar/types';

type DetalhamentoCreditosImportacaoValidacaoModal = {
    open: boolean;
    setOpen: Dispatch<SetStateAction<boolean>>;
    idDetalhamentoCreditoDebitoImportacao: number;
};

/**
 * Retorna as linhas para o grid de erros.
 */
const getRows = (data?: DetalhamentoImportacaoValidacao[]) => {
    return (
        data?.map((item) => ({
            id: item.idDetalhamentoCreditoDebitoImportacaoValidacao,
            ...item,
        })) || []
    );
};

export function DetalhamentoCreditosImportacaoValidacaoModal({
    open,
    setOpen,
    idDetalhamentoCreditoDebitoImportacao,
}: DetalhamentoCreditosImportacaoValidacaoModal) {
    const { data, isFetching, refetch } = useQueryDetalhamentoImportacaoValidacao({ idDetalhamentoCreditoDebitoImportacao, enabled: open });

    return (
        <ContentModal
            closeButton
            open={open}
            setOpen={setOpen}
            onClick={(event) => event.stopPropagation()} // evitar que ocorra erro ao clicar num campo da grid.
            sx={{
                borderRadius: 1,
                width: 600,
                maxWidth: '90vw',
                height: 600,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
            }}
        >
            <SubTitle label="Validações do processamento" sx={{ mb: 0 }} />

            <PanelGrid
                autoHeight={false}
                rows={getRows(data?.data)}
                rowsCount={data?.total || 0}
                loading={isFetching}
                reload={refetch}
                columns={[
                    {
                        field: 'dsDetalhamentoCreditoDebitoImportacaoValidacao',
                        headerName: 'Detalhes',
                        flex: 1,
                        sortable: false,
                        
                        renderCell: ({ row }) => <Box sx={{ whiteSpace: 'normal' }}>{row.dsDetalhamentoCreditoDebitoImportacaoValidacao}</Box>,
                    },
                ]}
            />
        </ContentModal>
    );
}
